<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YWEreQ/tc-custom/9781035843695.jpg?1718184629193" alt="This image is the cover for the book Sparkles and Fireworks on Pebble Bank Bay"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sparkles and Fireworks on Pebble Bank Bay
      </h1>
      <p class="bookDescription body article font2">
        <p>Millie works the night shift at her local hospital’s switchboard, feeling undervalued and unappreciated. She harbours regrets about not pursuing her dreams and her passion for music, particularly singing. However, her small Cumbrian town poses a challenge; with many pubs closed and those remaining already featuring regular bands and singers, opportunities seem scarce. This dynamic is set to change thanks to Pippa, the surrogate mother of Millie’s best friend, who presents a golden opportunity. For Millie, relocating to the South could be the break she needs. But this new chapter is complicated when Sam, the one man she’s never forgotten, unexpectedly reappears in her life. Meanwhile, Millie’s cousin Harry is secretly in love with Amber, Millie’s best friend. Although Harry confessed his feelings to Amber before she moved South, the outcome was unresolved. Millie encourages Harry to fight for Amber, believing they are meant to be together. Yet, unbeknownst to Amber, Harry harbours a significant secret, known only to Millie. As the story unfolds, the question remains: can Sam and Millie overcome their past differences and open up to each other? Will Millie let her guard down? There’s hope that the charm of Pebble Bank Bay will work its magic on these two couples.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Luisa Dejean
      </h2>
      
      <p class="authorDescription body article">Luisa Dejean lives in Hampshire with her two teenagers. She is a well-being coach and an advocate for the NSPCC. When she isn’t writing or working, you can guarantee she’ll be walking along the beach for new plot lines and twists. Or in the water paddle boarding. Luisa has a passion for all things Harry Potter, The Hobbit and The Lord of the Rings. As well as being a huge fan of rom-coms. You can follow Luisa on Twitter @LilyDGioAuthor and on Instagram and Threads @lilydigiovanni_author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cc720768